import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import nb from "./locales/nb";

export const SUPPORTED_LANGS = ["en", "nb"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

export const LANG_STORAGE_KEY = "visikt:lang";
const LEGACY_LANG_STORAGE_KEY = "sparr:lang";

function migrateStorageKey(oldKey: string, newKey: string) {
  if (typeof window === "undefined") return;
  try {
    if (window.localStorage.getItem(newKey) != null) return;
    const oldValue = window.localStorage.getItem(oldKey);
    if (oldValue != null) {
      window.localStorage.setItem(newKey, oldValue);
      window.localStorage.removeItem(oldKey);
    }
  } catch {
    // ignore
  }
}

function detectInitialLang(): Lang {
  if (typeof window === "undefined") return "en";
  try {
    migrateStorageKey(LEGACY_LANG_STORAGE_KEY, LANG_STORAGE_KEY);
    const stored = window.localStorage.getItem(LANG_STORAGE_KEY);
    if (stored === "nb" || stored === "en") return stored;
  } catch {
    // ignore
  }
  return "en";
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      nb: { translation: nb },
    },
    // Always start with `en` on server and first client render to keep SSR
    // hydration deterministic. We hydrate to the stored preference inside
    // an effect in the root component, then call `i18n.changeLanguage`.
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

export function applyStoredLanguage() {
  const lng = detectInitialLang();
  if (i18n.language !== lng) i18n.changeLanguage(lng);
}

export function setLanguage(lng: Lang) {
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(LANG_STORAGE_KEY, lng);
    } catch {
      // ignore
    }
  }
  if (i18n.language !== lng) i18n.changeLanguage(lng);
}

export default i18n;
